import React from "react";

export const Novedad = props => {
    return (
        <>
            <div className="novedadesHome--novedadImg novedadesHome--novedad  my-3qrt d-flex ml-2 cada_novedad">
                <p className="date">
                    <img className="mr-octa" src="/images/icons/fiat.svg" />
                    {props.date}
                </p>

                <h1 className="title mb-half">{props.title}</h1>
                <div className="img">
                    <img src={props.img} />
                </div>
                {props.children}
                {props.pdf && (
                    <a
                        download
                        target="blank"
                        className="btn-novedadHome"
                        href={props.pdf}
                    >
                        <button className="mt-half mb-half">
                            <p>{props.btn || "Descargar pdf"}</p>
                        </button>
                    </a>
                )}
                {props.descripcion && (
                    <a className="link" href={props.interna}>
                        Más información
                    </a>
                )}
                {props.link && (
                    <a className="link" href={props.link}>
                        Leer más
                    </a>
                )}
            </div>

            {/* {props.img ? (
                <div className="novedadesHome--novedadImg novedadesHome--novedad  my-3qrt d-flex ml-2 cada_novedad">
                    <div className="mr-xl-base">
                        <p className="date">
                            <img
                                className="mr-octa"
                                src="/images/icons/fiat.svg"
                            />
                            {props.date}
                        </p>
                        <h1 className="title">{props.title}</h1>
                        <p className="text mb-half">{props.children}</p>
                        {props.link && (
                            <a className="link" href={props.link}>
                                {props.btn}
                            </a>
                        )}
                    </div>
                    <div className="mt-half">
                        <img src={props.img} />
                        {props.pdf && (
                            <a
                                download
                                target="blank"
                                className="btn-novedadHome"
                                href={
                                    "downloadFile/" + props.id + "/" + props.pdf
                                }
                            >
                                <button className="mt-half">
                                    Descargar pdf
                                    <img
                                        className="ml-half"
                                        src="/images/icons/download.svg"
                                    />
                                </button>
                            </a>
                        )}
                    </div>
                    <div className="separator--ver separator--ver--black mt-half mb-octa"></div>
                </div>
            ) : (
                <>
                    {" "}
                    <div className="novedadesHome--novedad my-3qrt ml-2">
                        <p className="date">{props.date}</p>

                        <h1 className="title">{props.title}</h1>
                        {props.children}
                        {props.descripcion && (
                            <a className="link" href={props.interna}>
                                Leer más
                            </a>
                        )}
                        {props.link && (
                            <a className="link" href={props.link}>
                                {props.btn}
                            </a>
                        )}
                        {props.pdf && (
                            <a
                                download
                                target="blank"
                                className="btn-novedadHome"
                                href={props.pdf}
                            >
                                <button className="mt-half">
                                    Descargar pdf
                                    <img
                                        className="ml-half"
                                        src="/images/icons/download.svg"
                                    />
                                </button>
                            </a>
                        )}
                    </div>
                    <div className="separator--ver separator--ver--black mt-half mb-octa"></div>
                </>
            )} */}
        </>
    );
};
